import React, {useState, useEffect} from 'react'
import Searchbox from "./Searchbox";
import TagSearch from "./TagSearch";
import DateFilter from "./DateFilter";
import {getPosts} from '../../../firebase/getData';
import AdvancedSearch from "./AdvancedSearch";

export default function SearchWrapper(props) {
  const [activeTags, setActiveTags] = useState(tagsConfig)
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [lastPost, setLastPost] = useState(false);
  const {setLoading, setState, loadMore, setLoadMore, existingPosts, setNoMore} = props;

  useEffect(() => {
    //Consolidate tags, if any
    let sector = [];
    Object.keys(activeTags).forEach(tag => {
      if (activeTags[tag]) sector.push(tag)
    });
    setNoMore(false);
    
    if (sector.length !== 0) { //Works through tags + date + query, tags + query, tags + date, tags
      if (search) {
        if (startDate) getPosts({setState, search, sector, startDate, setLoading, setLastPost});
        else getPosts({setState, search, sector, setLoading, setLastPost});
      } else {
        if (startDate) getPosts({setState, sector, startDate, setLoading, setLastPost});
        else getPosts({setState, sector, setLoading, setLastPost});
      }
    } else if (search) { //Works through query + date, query
      if (startDate) getPosts({setState, search, startDate, setLoading, setLastPost});
      else getPosts({setState, search, setLoading, setLastPost});
    } else if (startDate) getPosts({setState, startDate, setLoading, setLastPost}); //Just date
    else getPosts({setState, setLoading, setLastPost}) //No filters

    //UI control
    setTimeout(() => setLoading(false), 3000);
  }, [activeTags, search, startDate]);

  useEffect(() => {
    //Consolidate tags, if any
    let sector = [];
    Object.keys(activeTags).forEach(tag => {
      if (activeTags[tag]) sector.push(tag)
    });

    if (loadMore) { //Pagination
      if (sector.length !== 0) { //Works through tags + date + query, tags + query, tags + date, tags
        if (search) {
          if (startDate) getPosts({setState, search, sector, startDate, setLoading, lastPost, setLastPost, existingPosts, setNoMore});
          else getPosts({setState, search, sector, setLoading, lastPost, setLastPost, existingPosts, setNoMore});
        } else {
          if (startDate) getPosts({setState, sector, startDate, setLoading, lastPost, setLastPost, existingPosts, setNoMore});
          else getPosts({setState, sector, setLoading, lastPost, setLastPost, existingPosts, setNoMore});
        }
      } else if (search) { //Works through query + date, query
        if (startDate) getPosts({setState, search, startDate, setLoading, lastPost, setLastPost, existingPosts, setNoMore});
        else getPosts({setState, search, setLoading, lastPost, setLastPost, existingPosts, setNoMore});
      } else if (startDate) getPosts({setState, startDate, setLoading, lastPost, setLastPost, existingPosts, setNoMore}); //Just date
      else getPosts({setState, setLoading, lastPost, setLastPost, existingPosts, setNoMore}) //No filters
      
      setLoadMore(false);
    }
  }, [loadMore])

  return (
    <div className="search-container">
      {showAdvanced && <AdvancedSearch showAdvanced={showAdvanced} setShowAdvanced={setShowAdvanced} setState={props.setState} setLoading={props.setLoading}/>}
      <Searchbox search={search} setSearch={setSearch}/>
      <TagSearch activeTags={activeTags} setActiveTags={setActiveTags}/>
      <DateFilter setStartDate={setStartDate} setShowAdvanced={setShowAdvanced}/>
    </div>
  )
}

const tagsConfig = {Retail: false, Fashion: false, Restaurant: false, Ecommerce: false, Home: false, Services: false, Food: false, Technology: false};